import type { RegionType } from "@shared/graphql.apollo";
import { useAppContext } from "hooks";

export const useRegion = (): RegionType => {
  const context = useAppContext();
  return context.region;
};
